import NextImage from "next/image";
import { Image, Link, Card, CardBody } from "@nextui-org/react";
import { GlobalSettings } from "@/configuration/global-settings";
import React, { useEffect, useRef, useState } from "react";
import { Carousel, IconButton } from "@material-tailwind/react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import SharedServiceInstance from "@/services/shared-service";
import { FaPlay } from "react-icons/fa6";
import PostMoreBlock from "@/components/shared/post-more-block";
import LoadingCommon from "@/components/shared/loadingCommon";
import { FiMoreHorizontal } from "react-icons/fi";
import { FaPause } from "react-icons/fa6";
import Head from "next/head";
import AudioHelper from "../../services/audio/helper";

function mergeCategories(parent, children) {
    const result = [];
    const parentCopy = JSON.parse(JSON.stringify(parent));

    parentCopy.forEach((parentItem) => {
        const matchingChildren = children.filter(
            (child) => child?.category?.id === parentItem.id
        );
        parentItem.children = matchingChildren;
        result.push(parentItem);
    });

    return result;
}

function CardMore({ cateParentURL }) {
    return (
        <>
            <Card className="xl:my-0 shadow-none sm:w-full text-news h-[268px]">
                <CardBody className="overflow-visible">
                    <Link href={cateParentURL}>
                        <div className="h-56 grid content-center mx-auto">
                            <p className="text-primary font-bold">Xem thêm</p>
                            <FiMoreHorizontal className="text-3xl text-primary mx-auto" />
                        </div>
                    </Link>
                </CardBody>
            </Card>
        </>
    );
}

function AudioChild({ item, index, onClick, selectedAudio, isPlay }) {
    return (
        <Card
            className="items-center rounded-[5px] border-0 lg:max-w-[400px] object-cover w-full"
            key={index}
        >
            <CardBody className="p-5">
                <NextImage
                    alt={item.title}
                    width={500}
                    height={500}
                    src={SharedServiceInstance.getOptimizeImage(
                        item.photo,
                        "main-post-view"
                    )}
                    className="rounded-[10px] w-full h-[10rem] object-cover"
                />
                <h5 className="text-sm font-bold mt-1 pl-1 line-clamp-2 min-h-[40px]">
                    {item.metaDescription}
                </h5>
                <div className="flex items-center mt-2 w-full justify-end">
                    <div onClick={() => onClick(item)}>
                        {isPlay && selectedAudio?.id === item?.id ? (
                            <FaPause className="text-primary m-auto" />
                        ) : (
                            <FaPlay className="text-primary m-auto" />
                        )}
                    </div>
                    <span className="ml-1 text-xs text-primary">
                        {item.visit || "0"}
                    </span>
                </div>
            </CardBody>
        </Card>
    );
}

export default function Audio() {
    const [selectedAudio, setSelectedAudio] = useState({});
    const [categoriesData, setCategoriesData] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [mappingCategories, setMappingCategories] = useState([]);
    const [urlAudio, setUrlAudio] = useState("");
    const [isPlay, setIsPlay] = useState(false);
    const [latestAudio, setLatestAudio] = useState({});
    const audioRef = useRef();
    const toastId = useRef(null);

    const fetchData = async () => {
        try {
            const res = await fetch(
                `${GlobalSettings.Settings.Server}/api/v1/audio/categories`
            );
            const data = await res.json();
            setCategoriesData(data?.results);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchSubCategories = async () => {
        try {
            if (categoriesData) {
                let tempSubCategories = [];

                for (let index = 0; index < categoriesData?.length; index++) {
                    const response = await fetch(
                        `${GlobalSettings.Settings.Server}/api/v1/audio/category-codes/${categoriesData[index].code}/episodes?pageSize=11`
                    );
                    const result = await response.json();
                    tempSubCategories = [
                        ...tempSubCategories,
                        ...result.results,
                    ];
                }

                setSubCategories(tempSubCategories);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchLatestAudio = async () => {
        try {
            const res = await fetch(
                `${GlobalSettings.Settings.Server}/api/v1/audio/episodes?type=latest&pageSize=1`
            );
            const data = await res.json();
            setLatestAudio(data?.results?.[0]);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchLatestAudio();
    }, []);

    useEffect(() => {
        fetchSubCategories();
    }, [categoriesData]);

    useEffect(() => {
        setMappingCategories(mergeCategories(categoriesData, subCategories));
    }, [categoriesData, subCategories]);

    useEffect(() => {
        AudioHelper.handlePlayAudio(
            isPlay,
            setIsPlay,
            selectedAudio,
            toastId,
            audioRef
        );
        if (isPlay) {
            fetchData();
        }
    }, [isPlay, urlAudio]);

    const playAudio = (item) => {
        setSelectedAudio(item);
        setUrlAudio(item?.mediaUrl);
        setIsPlay((prevState) => !prevState);
    };

    return (
        <>
            <Head>
                <title>GIÁO PHẬN PHÚ CƯỜNG - AUDIO</title>
            </Head>
            <div className="audio-latest mb-5 grid grid-cols-1 p-3">
                <div className="w-full rounded-[5px] object-contain">
                    <NextImage
                        priority
                        quality={100}
                        loading="eager"
                        layout="fill"
                        className="!w-full !relative rounded-[5px]"
                        alt="Audio Cover"
                        src={SharedServiceInstance.getOptimizeImage(
                            latestAudio?.photo,
                            "top-slider"
                        )}
                    />
                </div>
                <audio ref={audioRef} src={urlAudio} />
            </div>

            <div className="audio-categories grid grid-cols-1 sm:grid-cols-4 mb-5 gap-5 xl:gap-10 px-2 overflow-x-hidden">
                <div className="audio-categories--contain sm:col-span-3">
                    {mappingCategories !== undefined &&
                        mappingCategories.map((category) => {
                            // const subCategoryData =
                            //     subCategoriesData?.[category.code] || "";

                            return (
                                <>
                                    <div className="flex py-3">
                                        <h3 className="text-base leading-9 pl-3 font-bold sm:w-4/12 bg-primary block w-6/12">
                                            <Link
                                                href={`/audio/${category?.code}`}
                                                className="text-white "
                                            >
                                                {category.name}
                                            </Link>
                                        </h3>
                                        <hr className="sm:w-4/12 w-6/12 border-t-4 border-primary my-auto" />
                                    </div>

                                    {category.children.length === 0 && (
                                        <>
                                            <LoadingCommon
                                                itemName={category?.name}
                                            />
                                        </>
                                    )}

                                    <div className="md:hidden px-2 max-w-[380px]">
                                        <Carousel
                                            loop="true"
                                            autoplay={!isPlay}
                                            autoplayDelay={5000}
                                            className="rounded-none overflow-hidden"
                                            prevArrow={({ handlePrev }) => (
                                                <IconButton
                                                    variant="text"
                                                    color="white"
                                                    size="lg"
                                                    onClick={handlePrev}
                                                    className="!absolute top-2/4 left-4 -translate-y-2/4"
                                                >
                                                    <FaAngleLeft className="text-3xl" />
                                                </IconButton>
                                            )}
                                            nextArrow={({ handleNext }) => (
                                                <IconButton
                                                    variant="text"
                                                    color="white"
                                                    size="lg"
                                                    onClick={handleNext}
                                                    className="!absolute top-2/4 !right-4 -translate-y-2/4"
                                                >
                                                    <FaAngleRight className="text-3xl" />
                                                </IconButton>
                                            )}
                                            navigation={({
                                                setActiveIndex,
                                                activeIndex,
                                                length,
                                            }) => (
                                                <div className="absolute bottom-2 left-2/4 z-50 flex -translate-x-2/4 gap-2">
                                                    {new Array(length)
                                                        .fill("")
                                                        .map((_, i) => (
                                                            <span
                                                                key={i}
                                                                className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
                                                                    activeIndex ===
                                                                    i
                                                                        ? "w-8 bg-primary"
                                                                        : "w-4 bg-primary/50"
                                                                }`}
                                                                onClick={() =>
                                                                    setActiveIndex(
                                                                        i
                                                                    )
                                                                }
                                                            />
                                                        ))}
                                                </div>
                                            )}
                                        >
                                            {category?.children?.map(
                                                (subCat, index) => {
                                                    return (
                                                        <>
                                                            <div
                                                                key={index}
                                                                className=""
                                                            >
                                                                <AudioChild
                                                                    isPlay={
                                                                        isPlay
                                                                    }
                                                                    item={
                                                                        subCat
                                                                    }
                                                                    index={
                                                                        index
                                                                    }
                                                                    onClick={
                                                                        playAudio
                                                                    }
                                                                    selectedAudio={
                                                                        selectedAudio
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    );
                                                }
                                            )}
                                        </Carousel>
                                    </div>
                                    <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-2">
                                        {category?.children?.map(
                                            (subCat, index) => {
                                                return (
                                                    <>
                                                        <div key={index}>
                                                            <AudioChild
                                                                isPlay={isPlay}
                                                                item={subCat}
                                                                index={index}
                                                                onClick={
                                                                    playAudio
                                                                }
                                                                selectedAudio={
                                                                    selectedAudio
                                                                }
                                                            />
                                                        </div>
                                                    </>
                                                );
                                            }
                                        )}

                                        {/* 11 == item per category */}
                                        {category?.children?.length > 10 && (
                                            <CardMore
                                                cateParentURL={`/audio/${category?.code}`}
                                            />
                                        )}
                                    </div>
                                </>
                            );
                        })}
                </div>

                <div className="posts-categories--more sm:mt-12">
                    <PostMoreBlock categoryID={"loi-chua"} />
                </div>
            </div>
        </>
    );
}
